import React, { useState, useEffect } from "react";
import { getStudentIdData } from "../../../lib/studentpersonalquestion";
import { getDataWithType } from "../../../lib/parameters";
import GlobalQuestionEdit from "./globalquestionedit";
import Colleges from "../../instructor/studentGrid/sublist/colleges";
import GlobalCollegeList from "./globalcollegelist";

export default function GlobalStudentPersonelQuestionsList({ slug , isProfile = false}) {
  const [questionlist, setQuestionlist] = useState([]);
  const [newAnswer, setNewAnswer] = useState();
  const [studentQuestionList, setStudentQuestionList] = useState([]);
  const [collapseOpenClose, setCollapseOpenClose] = useState(false);

  const collapseAll = () => {
    setCollapseOpenClose(false);
  };

  const expandAll = () => {
    setCollapseOpenClose(true);
  };

  useEffect(() => {
    GetData();
  }, [newAnswer]);

  function getStudentData(qid) {
    if (studentQuestionList.length > 0) {
      const result = studentQuestionList.filter(
        (item) => item.questionId === qid
      );
      return result.length > 0 ? result[0].id : 0;
    } else return 0;
  }

  function getStudentQuestion(qid) {
    if (studentQuestionList.length > 0) {
      const result = studentQuestionList.filter(
        (item) => item.questionId === qid
      );

      let returnresult = false;

      if (result.length > 0) returnresult = result[0].isAnswer;

      return returnresult;
    } else return false;
  }

  function getStudentAnswer(qid) {
    if (studentQuestionList.length > 0) {
      const result = studentQuestionList.filter(
        (item) => item.questionId === qid
      );

      let returnresult = "";

      if (result.length > 0)
        returnresult =
          result[0].studentAnswer.length > 0
            ? result[0].studentAnswer
            : "No Answer";
      else returnresult = "Never Answered";

      return returnresult;
    } else return "";
  }

  async function GetData() {
    const qustions = await getDataWithType("PERSQUESTION");
    const sortedQuestionlist = qustions.sort((a, b) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });
    setQuestionlist(sortedQuestionlist);
    const stdquest = await getStudentIdData(slug);
    setStudentQuestionList(stdquest);
  }

  return (
    <div className="col-12">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk">
          <div className="d-flex justify-content-between align-items-center">
            <div className="profile-heading">
              <h3>Personality Assessment Survey</h3>
            </div>
            <div className="profile-heading">
              <button
                className="btn btn-outline-info"
                onClick={() => {
                  if (collapseOpenClose) {
                    setCollapseOpenClose(false);
                  } else {
                    setCollapseOpenClose(true);
                  }
                }}
              >
                {collapseOpenClose ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-chevron-double-up me-1"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                      <path
                        fillRule="evenodd"
                        d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                    </svg>{" "}
                    Collapse All
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="currentColor"
                      className="bi bi-chevron-double-down me-1"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                      <path
                        fillRule="evenodd"
                        d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                      />
                    </svg>{" "}
                    Expand All
                  </>
                )}
              </button>
            </div>
          </div>
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {questionlist.map(function (data, ix) {
                    return (
                      <React.Fragment key={data.questionId}>
                        <tr>
                          <td className="p-2">{data.pname}</td>
                          <td className="text-center">
                            <button
                              type="button"
                              className="btn btn-outline-info"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapseAnswer${ix}`}
                              aria-expanded={collapseOpenClose}
                              aria-controls={`collapseAnswer${ix}`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-arrows-angle-expand"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707m4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                        <tr
                          className={`collapse ${
                            collapseOpenClose ? "show" : ""
                          }`}
                          id={`collapseAnswer${ix}`}
                        >
                          <td colSpan={2}>
                            <GlobalQuestionEdit
                              value={getStudentAnswer(data.id)}
                              setValue={setNewAnswer}
                              id={getStudentData(data.id)}
                              questionId={data.id}
                              studentId={slug}
                            />
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {!isProfile && (
            <>
              <Colleges slug={slug} />
             {/*} <GlobalCollegeList slug={slug} isStudent={false} /> */}
            </>
          )}
    </div>
    
  );
}
